import { render, staticRenderFns } from "./hsbcOverallStatusDetail.vue?vue&type=template&id=4d736b0f&scoped=true"
import script from "./hsbcOverallStatusDetail.vue?vue&type=script&lang=js"
export * from "./hsbcOverallStatusDetail.vue?vue&type=script&lang=js"
import style0 from "./hsbcOverallStatusDetail.vue?vue&type=style&index=0&id=4d736b0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d736b0f",
  null
  
)

export default component.exports